import { RoleEnum } from '@shared/enums/role.enum';

export const acl = {
  '/home': [RoleEnum.User],
  '/people': [RoleEnum.User],
  '/organizations': [RoleEnum.User],
  '/events': [RoleEnum.Admin],
};
